export const GET_ORG_LIST_REQUEST = 'GET_ORG_LIST_REQUEST';
export const GET_ORG_LIST_SUCCESS = 'GET_ORG_LIST_SUCCESS';
export const GET_ORG_LIST_FAILURE = 'GET_ORG_LIST_FAILURE';

export const RESET_ORG_DROPDOWN_LIST = 'RESET_ORG_DROPDOWN_LIST';


export const GET_ORG_DETAIL_REQUEST = 'GET_ORG_DETAIL_REQUEST';
export const GET_ORG_DETAIL_SUCCESS = 'GET_ORG_DETAIL_SUCCESS';
export const GET_ORG_DETAIL_FAILURE = 'GET_ORG_DETAIL_FAILURE';

export const GET_ORG_CONTACTS_REQUEST = 'GET_ORG_CONTACTS_REQUEST';
export const GET_ORG_CONTACTS_DROPDOWN_SUCCESS = 'GET_ORG_CONTACTS_DROPDOWN_SUCCESS';
export const GET_ORG_CONTACTS_SUCCESS = 'GET_ORG_CONTACTS_SUCCESS';
export const GET_ORG_CONTACTS_FAILURE = 'GET_ORG_CONTACTS_FAILURE';

export const GET_ORG_END_USERS_REQUEST = 'GET_ORG_END_USERS_REQUEST';
export const GET_ORG_END_USERS_SUCCESS = 'GET_ORG_END_USERS_SUCCESS';
export const GET_ORG_END_USERS_FAILURE = 'GET_ORG_END_USERS_FAILURE';
export const GET_ORG_END_USERS_DROPDOWN_SUCCESS = 'GET_ORG_END_USERS_DROPDOWN_SUCCESS';

export const GET_ORG_BRANCHES_REQUEST = 'GET_ORG_BRANCHES_REQUEST';
export const GET_ORG_BRANCHES_SUCCESS = 'GET_ORG_BRANCHES_SUCCESS';
export const GET_ORG_BRANCHES_FAILURE = 'GET_ORG_BRANCHES_FAILURE';
export const GET_ORG_BRANCHES_DROPDOWN_SUCCESS = 'GET_ORG_BRANCHES_DROPDOWN_SUCCESS';

export const POST_ENTITIES_REQUEST = 'POST_ENTITIES_REQUEST'

export const CLEAR_ORG_BRANCHES_DROPDOWN_LIST_DATA = 'CLEAR_ORG_BRANCHES_DROPDOWN_LIST_DATA'
export const CLEAR_ORG_CONTACTS_DROPDOWN_LIST_DATA = 'CLEAR_ORG_CONTACTS_DROPDOWN_LIST_DATA'
export const CLEAR_ORG_LIST_DROPDOWN_LIST_DATA = 'CLEAR_ORG_LIST_DROPDOWN_LIST_DATA'
export const CLEAR_VENDOR_ORG_LIST_DROPDOWN_LIST_DATA = 'CLEAR_VENDOR_ORG_LIST_DROPDOWN_LIST_DATA'
export const CLEAR_ORG_END_USERS_DROPDOWN_LIST_DATA = 'CLEAR_ORG_END_USERS_DROPDOWN_LIST_DATA'

export const GET_ORG_DROPDOWN_LIST_DATA_SUCCESS = 'GET_ORG_DROPDOWN_LIST_DATA_SUCCESS'
export const GET_VENDOR_ORG_DROPDOWN_LIST_DATA_SUCCESS = 'GET_VENDOR_ORG_DROPDOWN_LIST_DATA_SUCCESS'

export const GET_PO_ORG_DROPDOWN_LIST_DATA_SUCCESS = 'GET_PO_ORG_DROPDOWN_LIST_DATA_SUCCESS'
export const CLEAR_PO_ORG_LIST_DROPDOWN_LIST_DATA = 'CLEAR_PO_ORG_LIST_DROPDOWN_LIST_DATA'
export const GET_PO_TERMS_AND_CONDITIONS_LIST_SUCCESS = 'GET_PO_TERMS_AND_CONDITIONS_LIST_SUCCESS'